import { render } from "./ReturnProducts.vue?vue&type=template&id=5e9aff66"
import script from "./ReturnProducts.vue?vue&type=script&lang=js"
export * from "./ReturnProducts.vue?vue&type=script&lang=js"

import "./ReturnProducts.vue?vue&type=style&index=0&id=5e9aff66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__